import { useCallback, useState } from 'react';

interface OnboardingFormState {
  token: string;
  email: string;
}
const useUserOnboardingFormState = () => {
  const [state, setState] = useState({
    token: '',
    email: '',
  });

  const updateState = useCallback((newState: Partial<OnboardingFormState>) => {
    setState((prev) => {
      return {
        ...prev,
        ...newState,
      };
    });
  }, []);

  return {
    state,
    setState,
    updateState,
  };
};

export default useUserOnboardingFormState;
